export const redeemMarkup = String.raw`<div class="view" id="view-redeem">
  <section class="pricing-page redeem-page">
    <header class="contextual-page-header">
      <div class="topic-back-row">
        <button type="button" class="btn btn-default btn-sm topic-back-pill" data-redeem-back data-proto-click="backFromRedeem()" aria-label="Back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </button>
      </div>
      <h1 class="heading-1">Redeem your pass</h1>
      <p>Enter a code to preview its reward before claiming it.</p>
    </header>
    <div class="profile-card redeem-card">
      <label class="wizard-label" for="redeemCodeInput">Redemption code</label>
      <div class="redeem-input-row"><input id="redeemCodeInput" class="input" autocomplete="off" spellcheck="false" minlength="8" maxlength="64" pattern="[A-Za-z0-9_-]{8,64}" placeholder="8–64 characters" data-reset-on-enter><button class="btn btn-outline" data-proto-click="previewPromotionCode()">Preview</button></div>
      <p id="redeemFeedback" role="status" aria-live="polite" class="redeem-feedback" data-transient-feedback></p>
      <div id="redeemPreview" class="redeem-preview" hidden data-reset-view="hide">
        <div class="redeem-code-summary"><span>Code entered</span><strong id="redeemCodeSummary"></strong></div>
        <dl class="redeem-details">
          <div><dt>Reward</dt><dd><strong id="redeemReward"></strong><span id="redeemDetail"></span></dd></div>
          <div id="redeemPaidPlanRow"><dt>Your paid membership</dt><dd id="redeemPaidPlan">Free</dd></div>
          <div id="redeemAccessAfterRow"><dt id="redeemAccessAfterLabel">Promotional pass after claim</dt><dd id="redeemAccessAfter">—</dd></div>
          <div id="redeemCreditsRow"><dt>AI Credits</dt><dd id="redeemCredits">No AI Credits included</dd></div>
          <div><dt>Countdown starts</dt><dd>Immediately</dd></div>
        </dl>
        <div class="redeem-billing-note"><span>Claiming this reward will not change your paid plan, billing date, or renewal amount.</span></div>
        <button id="redeemClaimButton" class="btn btn-primary redeem-claim" disabled data-proto-click="redeemPromotionCode()" data-transient-action data-idle-label="Claim reward" data-idle-disabled="true">Claim reward</button>
      </div>
      <div id="redeemSuccess" class="redeem-success" hidden data-reset-view="hide"><strong id="redeemSuccessTitle"></strong><span id="redeemSuccessDetail"></span></div>
    </div>
  </section>
</div>`;
